import React from "react";
import { Link, useLocation } from "react-router-dom";

function BookingSidebar(props) {
  const location = useLocation();
  const { pathname } = location;
  return (
    <div className="w-full no-scrollbar md:w-[20%] p-3 border-slate-200 bg-white md:overflow-x-scroll md:border-b md:border-b-0 md:space-y-3">
      <h3 className="text-2xl font-semibold md:text-base md:font-medium">
        Booking
      </h3>
      <p className="hidden md:block font-light text-xs text-slate-400">
        These are all the booking that you have created.
      </p>

      <ul className="flex flex-nowrap mt-5 mr-3 md:block md:mt-0">
        <SidebarItem
          text="Overview"
          path="/booking/overview"
          active={pathname.includes("overview")}
        >
          <svg
            className="w-4 h-4 shrink-0 fill-current text-slate-400 mr-2"
            viewBox="0 0 16 16"
          >
            <path d="M12.311 9.527c-1.161-.393-1.85-.825-2.143-1.175A3.991 3.991 0 0012 5V4c0-2.206-1.794-4-4-4S4 1.794 4 4v1c0 1.406.732 2.639 1.832 3.352-.292.35-.981.782-2.142 1.175A3.942 3.942 0 001 13.26V16h14v-2.74c0-1.69-1.081-3.19-2.689-3.733zM6 4c0-1.103.897-2 2-2s2 .897 2 2v1c0 1.103-.897 2-2 2s-2-.897-2-2V4zm7 10H3v-.74c0-.831.534-1.569 1.33-1.838 1.845-.624 3-1.436 3.452-2.422h.436c.452.986 1.607 1.798 3.453 2.422A1.943 1.943 0 0113 13.26V14z" />
          </svg>
        </SidebarItem>

        <SidebarItem
          text="Create"
          path="/booking/create"
          active={pathname.includes("create")}
        >
          <svg
            viewBox="0 0 20 20"
            fill="none"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="w-4 h-4 shrink-0 stroke-current stroke-2 text-[--bg-color-400] mr-2"
          >
            <path d="M13 5C14.1046 5 15 5.89543 15 7M19 7C19 10.3137 16.3137 13 13 13C12.3938 13 11.8087 12.9101 11.2571 12.7429L9 15H7V17H5V19H2C1.44772 19 1 18.5523 1 18V15.4142C1 15.149 1.10536 14.8946 1.29289 14.7071L7.25707 8.74293C7.08989 8.19135 7 7.60617 7 7C7 3.68629 9.68629 1 13 1C16.3137 1 19 3.68629 19 7Z" />
          </svg>
        </SidebarItem>

        <SidebarItem
          text="Design"
          path="/booking/design"
          active={pathname.includes("design")}
        >
          <svg
            className="w-4 h-4 shrink-0 fill-current text-slate-400 mr-2"
            viewBox="0 0 16 16"
          >
            <path d="M12.311 9.527c-1.161-.393-1.85-.825-2.143-1.175A3.991 3.991 0 0012 5V4c0-2.206-1.794-4-4-4S4 1.794 4 4v1c0 1.406.732 2.639 1.832 3.352-.292.35-.981.782-2.142 1.175A3.942 3.942 0 001 13.26V16h14v-2.74c0-1.69-1.081-3.19-2.689-3.733zM6 4c0-1.103.897-2 2-2s2 .897 2 2v1c0 1.103-.897 2-2 2s-2-.897-2-2V4zm7 10H3v-.74c0-.831.534-1.569 1.33-1.838 1.845-.624 3-1.436 3.452-2.422h.436c.452.986 1.607 1.798 3.453 2.422A1.943 1.943 0 0113 13.26V14z" />
          </svg>
        </SidebarItem>
        <SidebarItem
          text="Update"
          path="/booking/overview"
          active={pathname.includes("update")}
        >
          <svg
            className="w-4 h-4 shrink-0 fill-current text-slate-400 mr-2"
            viewBox="0 0 16 16"
          >
            <path d="M12.311 9.527c-1.161-.393-1.85-.825-2.143-1.175A3.991 3.991 0 0012 5V4c0-2.206-1.794-4-4-4S4 1.794 4 4v1c0 1.406.732 2.639 1.832 3.352-.292.35-.981.782-2.142 1.175A3.942 3.942 0 001 13.26V16h14v-2.74c0-1.69-1.081-3.19-2.689-3.733zM6 4c0-1.103.897-2 2-2s2 .897 2 2v1c0 1.103-.897 2-2 2s-2-.897-2-2V4zm7 10H3v-.74c0-.831.534-1.569 1.33-1.838 1.845-.624 3-1.436 3.452-2.422h.436c.452.986 1.607 1.798 3.453 2.422A1.943 1.943 0 0113 13.26V14z" />
          </svg>
        </SidebarItem>
      </ul>
    </div>
  );
}

const SidebarItem = ({ children, text, path, active }) => {
  return (
    <li className="grow mr-0.5 md:mr-0 md:mb-0.5">
      <Link
        to={path}
        className={
          "w-full flex justify-center items-center px-2.5 py-2 rounded whitespace-nowrap hover:!bg-[--bg-color-50] border border-slate-200 hover:border-slate-300 text-slate-600 md:justify-start md:border-none " +
          (active ? "!bg-[--bg-color-50]" : "")
        }
      >
        {children}
        <span className="text-xs">{text}</span>
      </Link>
    </li>
  );
};

export default BookingSidebar;
